const API_BASE_URL = '/custom-includes/php/api/review_api.php';

class ReviewApiService {
  async makeRequest(endpoint, params = {}) {
    try {
      const url = new URL(API_BASE_URL, window.location.origin);
      url.searchParams.append('endpoint', endpoint);
      
      Object.keys(params).forEach(key => {
        if (params[key] !== null && params[key] !== undefined) {
          url.searchParams.append(key, params[key]);
        }
      });

      const response = await fetch(url);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (error) {
      console.error('Review API request failed:', error);
      throw error;
    }
  }

  async getAllReviews(limit = null, offset = 0) {
    const params = {};
    if (limit) params.limit = limit;
    if (offset) params.offset = offset;
    return this.makeRequest('reviews', params);
  }

  async getReviewById(id) {
    return this.makeRequest('review', { id });
  }

  async getReviewBySlug(slug) {
    return this.makeRequest('review', { slug });
  }

  async getReviewByState(stateId) {
    return this.makeRequest('review-by-state', { state_id: stateId });
  }

  async getReviewsWithLocation() {
    return this.makeRequest('reviews-with-location');
  }

  async getRecentReviews(limit = 5) {
    return this.makeRequest('recent', { limit });
  }

  async getReviewsByRating(rating, limit = null, offset = 0) {
    const params = { rating };
    if (limit) params.limit = limit;
    if (offset) params.offset = offset;
    return this.makeRequest('reviews-by-rating', params);
  }

  async searchReviews(query, limit = null, offset = 0) {
    const params = { q: query };
    if (limit) params.limit = limit;
    if (offset) params.offset = offset;
    return this.makeRequest('search', params);
  }

  async createReview(reviewData) {
    const params = {
      method: 'POST',
      reviewer_name: reviewData.reviewer_name || reviewData.client_name || '',
      reviewer_email: reviewData.reviewer_email || null,
      reviewer_company: reviewData.reviewer_company || reviewData.client_company || null,
      reviewer_avatar: reviewData.reviewer_avatar || reviewData.image || null,
      review_text: reviewData.review_text || reviewData.description || '',
      rating: reviewData.rating || 5,
      platform: reviewData.platform || 'Google',
      platform_url: reviewData.platform_url || null,
      review_date: reviewData.review_date || new Date().toISOString().slice(0, 19).replace('T', ' '),
      display_order: reviewData.display_order || 0,
      is_featured: reviewData.is_featured || false,
      state_id: reviewData.state_id || null,
      state_name: reviewData.state_name || null,
      title: reviewData.title || null,
      subtitle: reviewData.subtitle || null
    };
    return this.makeRequest('create-review', params);
  }

  async updateReview(reviewId, reviewData) {
    const params = {
      method: 'PUT',
      review_id: reviewId,
      reviewer_name: reviewData.reviewer_name || reviewData.client_name,
      reviewer_email: reviewData.reviewer_email,
      reviewer_company: reviewData.reviewer_company || reviewData.client_company,
      reviewer_avatar: reviewData.reviewer_avatar || reviewData.image,
      review_text: reviewData.review_text || reviewData.description,
      rating: reviewData.rating,
      platform: reviewData.platform,
      platform_url: reviewData.platform_url,
      display_order: reviewData.display_order,
      is_featured: reviewData.is_featured,
      title: reviewData.title,
      subtitle: reviewData.subtitle
    };
    // Remove undefined values
    Object.keys(params).forEach(key => {
      if (params[key] === undefined) {
        delete params[key];
      }
    });
    return this.makeRequest('update-review', params);
  }

  async deleteReview(reviewId) {
    return this.makeRequest('delete-review', { review_id: reviewId, method: 'DELETE' });
  }

  async getMapReviews() {
    return this.makeRequest('map-reviews');
  }
}

const reviewApi = new ReviewApiService();
export default reviewApi;